import Icon from '../components/Icon.vue'

Icon.register({
  'parachute-box': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M511.9 175c1.1 9.2-6.8 17-16.1 17h-8.7l-136.8 151.9c0.7 2.7 1.6 5.2 1.6 8.1v128c0 17.7-14.3 32-32 32h-128c-17.7 0-32-14.3-32-32v-128c0-2.9 0.9-5.5 1.6-8.1l-136.7-151.9h-8.7c-9.2 0-17.1-7.9-16-17 9.1-75.5 78.4-132.3 158.3-158.7-36.4 39.4-62.4 100.6-62.4 175.7h-28.1l116.6 129.5c2.5-0.6 4.8-1.5 7.5-1.5h48v-128h-112c0-115.2 68.9-192 128-192s128 76.8 128 192h-112v128h48c2.7 0 5 0.9 7.5 1.5l116.6-129.5h-28.1c0-75.1-26-136.3-62.4-175.7 79.9 26.3 149.2 83.1 158.3 158.7z'
      }
    ]
  }
})
